import { useState, useRef, forwardRef, useImperativeHandle } from "react";
import { useWindowSize } from "../../../utils/useWindowSize";

import { Box, Stack, Button, Typography, Drawer, Tooltip } from "@mui/material";
import CelebrationIcon from "@mui/icons-material/Celebration";

import { userState } from "../../../interface/MainInterface";
import Toast from "../../../utils/Toast";

import CreateEventFormMudule from "./LiveEventModules/CreateEventFormMudule";
import LiveEventListModule from "./LiveEventModules/LiveEventListModule";
import LiveEventDetailModule from "./LiveEventModules/LiveEventDetailModule";

interface propsType {
  userState: userState;
  channelInfo: any;
  callback: any;
}

const LiveEventManagement = (props: propsType, ref: any) => {
  const windowSize = useWindowSize();
  const toastRef: any = useRef();

  const [open, setOpen] = useState(false);
  const [openCreateEventForm, setOpenCreateEventForm] = useState(false);

  const liveEventListRef: any = useRef();
  const liveEventDetailRef: any = useRef();

  const closeCreateEventForm = () => {
    setOpenCreateEventForm(false);
  };

  const get_event_list_total = (_event_seq: string) => {
    liveEventListRef.current.get_event_list();
    liveEventDetailRef.current.get_event_info(props.channelInfo.broad_seq, _event_seq);
  };

  useImperativeHandle(ref, () => ({
    get_event_list_total,
  }));

  return (
    <>
      <Box
        sx={{ cursor: "pointer", minWidth: "70px" }}
        onClick={() => {
          setOpen(true);
        }}
      >
        <Stack
          direction={"column"}
          spacing={0}
          sx={{
            backgroundColor: "#1876d2",
            color: "#ffffff",
            borderRadius: "7px",
            p: 1,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <CelebrationIcon />
          </Box>
          <Typography sx={{ fontSize: "14px", textAlign: "center" }}>이벤트</Typography>
        </Stack>
      </Box>
      <Drawer
        anchor={windowSize.width > 768 ? "right" : "top"}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Box sx={{ width: windowSize.width > 768 ? "78vw" : "100%" }}>
          <Box sx={{ p: 2 }}>
            <Stack direction={"column"} spacing={2}>
              <Typography sx={{ fontSize: "18px", fontWeight: "700" }}>라이브 이벤트 관리</Typography>
              <Box>
                <Stack direction={"column"} spacing={1}>
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Stack direction={"row"} spacing={2}>
                      <Box>
                        <Button
                          variant="contained"
                          onClick={() => {
                            liveEventListRef.current.get_event_list();
                          }}
                        >
                          조회
                        </Button>
                      </Box>
                      <Box>
                        <Tooltip
                          title="이벤트 생성은 TIS를 이용해주세요."
                          disableHoverListener={props.userState.isSuperAdmin}
                        >
                          <span>
                            <Button
                              variant="outlined"
                              disabled={!props.userState.isSuperAdmin}
                              onClick={() => {
                                setOpenCreateEventForm((prev) => !prev);
                              }}
                            >
                              이벤트 생성
                            </Button>
                          </span>
                        </Tooltip>
                        {/* <Button
                          variant="outlined"
                          disabled={!props.userState.isSuperAdmin}
                          onClick={() => {
                            if (props.userState.isSuperAdmin) {
                              setOpenCreateEventForm((prev) => !prev);
                            } else {
                              window.alert("이벤트 생성은 TIS를 이용해주세요.");
                            }
                          }}
                        >
                          이벤트 생성
                        </Button> */}
                      </Box>
                      <Box>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setOpen(false);
                          }}
                        >
                          닫기
                        </Button>
                      </Box>
                    </Stack>
                  </Box>
                  {openCreateEventForm && (
                    //이벤트 생성 폼
                    <CreateEventFormMudule
                      userState={props.userState}
                      channelInfo={props.channelInfo}
                      callback={(payload: any) => {
                        if (payload.command === "finish_create_evnet") {
                          toastRef.current?.toast("이벤트를 생성했습니다.", "success", 4000, {
                            vertical: "top",
                            horizontal: "center",
                          });
                          liveEventListRef.current.get_event_list();
                          closeCreateEventForm();
                        }
                      }}
                      eventCount={liveEventListRef.current?.get_event_count() ?? 0}
                      closeCreateEventForm={closeCreateEventForm}
                    />
                  )}
                  {/* 이벤트 리스트 */}
                  <LiveEventListModule
                    ref={liveEventListRef}
                    userState={props.userState}
                    channelInfo={props.channelInfo}
                    callback={(payload: any) => {
                      if (payload.command === "select_row") {
                        liveEventDetailRef.current.get_event_info(props.channelInfo.broad_seq, payload.info.sk);
                      }
                    }}
                  />
                  {/* 이벤트 상세보기 */}
                  <LiveEventDetailModule
                    ref={liveEventDetailRef}
                    userState={props.userState}
                    channelInfo={props.channelInfo}
                    callback={(payload: any) => {
                      if (
                        payload.command === "start_event" ||
                        payload.command === "select_game" ||
                        payload.command === "update_game"
                      ) {
                        liveEventListRef.current.get_event_list();
                        liveEventDetailRef.current.get_event_info(props.channelInfo.broad_seq, payload.info.sk);
                      }
                    }}
                  />
                </Stack>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Drawer>
      <Toast ref={toastRef} />
    </>
  );
};

export default forwardRef(LiveEventManagement);
